import React, { useState } from 'react';
// @ts-ignore
import BootstrapTable from 'react-bootstrap-table-next';
// @ts-ignore
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit'
// @ts-ignore
import cellEditFactory from 'react-bootstrap-table2-editor';
// @ts-ignore
import paginationFactory, { PaginationProvider, SizePerPageDropdownStandalone, PaginationListStandalone } from 'react-bootstrap-table2-paginator';
// @ts-ignore
import classNames from 'classnames';
import styles from './Table.module.scss';
import './styles.css';
import { ColumnType  as ColumnTypeOrigin } from './types/ColumnType';

export interface IPaginationFactoryProps {
    custom?: boolean,
    page?: number,
    sizePerPage?: number,
    totalSize?: number,
    hideSizePerPage?: boolean,
    alwaysShowAllBtns?: boolean,
    hidePageListOnlyOnePage?: boolean,
    onPageChange?: (value: any) => void
};

type PropsType = {
    keyField: string,
    /**
     * Expected array of objec as ColumnType[] type
     */
    columns: ColumnType[],
    /**
     * Expected array of object as `{ [columnName]: value }`
     */
    data: any[],
    id?: string,
    classes?: string,
    cellEdit?: any
    defaultSorted?: any,
    expandRow?: any,
    nonEditableRows?: number[],
    onTableChange?: any,
    selectRow?: any,
    variant?: string,
    remote?: boolean,
    search?: boolean,
    wrapperClasses?: string,
    isDataLoading?: boolean,
    paginationProps?: IPaginationFactoryProps,
    paginationWrapperClass?: string,
    paginationListClass?: string,
    sizePerPageWrapperClass?: string,
    sizePerPageRowLabelClass?: string,
    sizePerPageDropdownWrapperClass?: string,
    dataCy?: string,
    /**
     * Expected function as () => Promise<void>
     */
    onExport?: () => Promise<void>
    /**
     * Expected function as () => JSX.Element
     */
    noDataIndication?: () => JSX.Element,
    /**
     * Expected function as (row: any) => string
     */
    rowClasses?: (row: any) => string,
};

const CustomSearchBar = (props: any) => {
    let input: any;
    const handleClick = () => {
      props.onSearch(input.value);
    };

    return (
      <div className="c-data-table__searchbar">
          <div className="row">
              <div className="col">
                <input
                    ref={ n => input = n }
                    type="text"
                    className="c-form-control"
                />
              </div>

              <div className="col-auto">
                <button 
                    type="button" 
                    onClick={handleClick}
                >
                    Search
                </button>
              </div>
          </div>
      </div>
    );
};

const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange
  }: any) => (
    <div className={styles.sizePerPageListClass} role="group">
      {
        options.map((option: any) => {
          const isSelect = currSizePerPage === `${styles.sizePerPageListActiveItemClass}`;
          return (
            <button
              key={ option.text }
              type="button"
              onClick={ () => onSizePerPageChange(option.page) }
              className={classNames(isSelect, styles.sizePerPageListItemClass)}
            >
              { option.text }
            </button>
          );
        })
      }
    </div>
  );

const TableCore = (props: PropsType) => {
    const [currentPage, setCurrentPage] = useState<number>(1);
    
    const pagination = {
        page: props.paginationProps ? props.paginationProps.page || currentPage : currentPage,
        sizePerPage: props.paginationProps ? props.paginationProps.sizePerPage || 10 : 10,
        totalSize: props.paginationProps ? props.paginationProps.totalSize || props.data.length : props.data.length,
        hideSizePerPage: props.paginationProps ? props.paginationProps.hideSizePerPage : undefined,
        alwaysShowAllBtns: props.paginationProps ? props.paginationProps.alwaysShowAllBtns || undefined : undefined,
        hidePageListOnlyOnePage: props.paginationProps ? props.paginationProps.hidePageListOnlyOnePage : undefined,
    };

    // const rowsTableLoader = props.paginationProps ? props.paginationProps.sizePerPage : 5;
    const handlePageChange = (value: number) => {
        if (props.paginationProps && props.paginationProps.onPageChange) {
            props.paginationProps.onPageChange(value);
        }

        setCurrentPage(value);
    }

    return (
        <>
            {!props.columns || props.columns.length === 0 || props.isDataLoading ? (
                <div className="table-loader">
                    {/* <div className="table-loader__head"></div>

                    <div className="table-loader__body">
                        {[...Array(rowsTableLoader)].map((x, i) =>
                            <div className="table-loader__row" key={i}>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        )}
                    </div> */}
                </div>
            ) : (
                <PaginationProvider
                    pagination={paginationFactory({
                        custom: true,
                        page: pagination.page,
                        sizePerPage: pagination.sizePerPage,
                        totalSize: pagination.totalSize,
                        hideSizePerPage: pagination.hideSizePerPage,
                        alwaysShowAllBtns: pagination.alwaysShowAllBtns,
                        hidePageListOnlyOnePage: pagination.hidePageListOnlyOnePage,
                        sizePerPageRenderer: sizePerPageRenderer,
                        onPageChange: handlePageChange
                    })}
                >
                    {({
                        paginationProps,
                        paginationTableProps
                    }: any) => (
                        <div className={`c-data-table ${pagination.hideSizePerPage ? 'c-data-table--hideSizePerPage' : ''} ${props.variant ? `c-data-table--${props.variant}` : ''}`}>
                          {paginationProps && !paginationProps.hideSizePerPage ? 
                        <div className={classNames(props.sizePerPageWrapperClass, styles.sizePerPageWrapperClass)}>
                        <label className={classNames(props.sizePerPageRowLabelClass, styles.sizePerPageRowLabelClass)}>
                          Rows
                        </label>

                        <SizePerPageDropdownStandalone
                          className={classNames(props.sizePerPageDropdownWrapperClass, 
                            styles.sizePerPageDropdownWrapperClass)}
                          {...paginationProps}
                        />
                        </div> : null
                            }

                            {props.remote ? (
                                <BootstrapTable
                                    id={props.id}
                                    wrapperClasses={classNames(props.wrapperClasses, styles.wrapper)}
                                    classes={classNames(props.classes, styles.table)}
                                    remote={{ pagination: true }}
                                    keyField={props.keyField}
                                    alwaysShowAllBtns={true}
                                    data={props.data}
                                    rowClasses={props.rowClasses}
                                    columns={props.columns}
                                    onTableChange={props.onTableChange}
                                    expandRow={props.expandRow}
                                    noDataIndication={() => <NoDataIndication component={props.noDataIndication} />}
                                    defaultSorted={props.defaultSorted}
                                    selectRow={props.selectRow}
                                    {...paginationTableProps}
                                    data-cy={props.dataCy}
                                />
                            ) : (
                                <ToolkitProvider
                                    keyField={props.keyField}
                                    data={props.data}
                                    columns={props.columns}
                                    search
                                >
                                  {
                                    (toolkitProps: any) => (
                                    <>
                                    {props.search && (
                                      <CustomSearchBar { ...toolkitProps.searchProps } />
                                    )}

                                    <BootstrapTable
                                      wrapperClasses={classNames(props.wrapperClasses, styles.wrapper)}
                                      classes={classNames(props.classes, styles.table)}
                                      keyField={props.keyField}
                                      data={props.data}
                                      columns={props.columns}
                                      rowClasses={props.rowClasses}
                                      selectRow={props.selectRow}
                                      noDataIndication={() => <NoDataIndication component={props.noDataIndication} />}
                                      onTableChange={props.onTableChange}
                                      expandRow={props.expandRow}
                                      defaultSorted={props.defaultSorted}
                                      cellEdit={cellEditFactory(props.cellEdit)}
                                      {...paginationTableProps}
                                      {...toolkitProps.baseProps}
                                      data-cy={props.dataCy}
                                      />
                                    </>
                                    )}
                                </ToolkitProvider>
                            )}

                            <div className={classNames(props.paginationWrapperClass, styles.paginationWrapperClass)}>
                                <PaginationListStandalone
                                    {...paginationProps}
                                />
                            </div>
                        </div>
                    )}
                </PaginationProvider>
            )}
        </>
    )
};

const NoDataIndication = (props: any) => {
    return (
        props.component ? (
            <props.component />
        ) : (
            <div className={styles.noDataIndication}>
                No data to display
            </div>
        )
    )
}

export default TableCore;
export type ColumnType = ColumnTypeOrigin;
export type TablePropsType = PropsType; 
